export interface CurationItemId {
  id: string;
  revisionId: string;
}
